<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="my-land-and-people-of-origin">
<h1 style="font-family:Arial; padding-top:180px;">My Land and People of Origin</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?100e8e5a